module.exports = __webpack_public_path__ + "static/media/expressjs.98ce354a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/expressjs.png
// module id = 52
// module chunks = 0